<header
    class="navbar sticky-top bg-warning flex-md-nowrap p-2 shadow text-center"
    *ngIf="remainingSeconds !== null"
>
    <span>Logging out in {{ remainingTimeFriendly }}</span>
    <a class="btn btn-secondary" (click)="resetSession()">Stay logged in</a>
</header>
